import PageLayout from "./getinvolve/PageLayout ";

export default function TermsConditions() {
  return (
    <PageLayout
      title="Terms & Conditions"
      desc="Please read these terms carefully before using our platform and services."
    >
      <div className="advocacy-content">
        <p>
          Welcome to ICSAJ (International Council of Sanatan Advocacy &
          Justice). By accessing or using our website, services, or any
          associated platforms, you agree to comply with and be bound by the
          following Terms & Conditions. These terms govern your use of our
          website and participation in our initiatives.
        </p>

        <p>
          If you do not agree with any part of these terms, you are advised not
          to use our services. Your continued use of the platform constitutes
          acceptance of these terms.
        </p>

        <h4 className="mt-4">Use of Website</h4>
        <p>
          The content provided on this website is for general informational and
          educational purposes only. Users agree to use the platform responsibly
          and not engage in any activity that may harm, disrupt, or misuse the
          website or its services.
        </p>

        <h4 className="mt-4">User Responsibilities</h4>
        <ul className="advocacy-list">
          <li>Provide accurate and truthful information</li>
          <li>Use the platform for lawful purposes only</li>
          <li>Avoid submitting false, misleading, or harmful content</li>
          <li>Respect the rights and privacy of others</li>
        </ul>

        <p>
          ICSAJ reserves the right to restrict or terminate access to users who
          violate these terms or engage in inappropriate conduct.
        </p>

        <h4 className="mt-4">Intellectual Property</h4>
        <p>
          All content, including text, graphics, logos, and materials available
          on this website, are the intellectual property of ICSAJ unless stated
          otherwise. Unauthorized use, reproduction, or distribution of content
          without prior permission is strictly prohibited.
        </p>

        <h4 className="mt-4">Third-Party Links</h4>
        <p>
          Our website may include links to third-party websites for additional
          information. ICSAJ does not control or take responsibility for the
          content, policies, or practices of these external sites.
        </p>

        <h4 className="mt-4">Limitation of Liability</h4>
        <p>
          ICSAJ shall not be held liable for any direct, indirect, incidental,
          or consequential damages arising from the use or inability to use our
          website or services. While we strive to ensure accuracy, we do not
          guarantee that all information is complete or error-free.
        </p>

        <h4 className="mt-4">Privacy</h4>
        <p>
          Your use of our website is also governed by our Privacy Policy. By
          using this platform, you consent to the collection and use of
          information as outlined in that policy.
        </p>

        <h4 className="mt-4">Modifications to Terms</h4>
        <p>
          ICSAJ reserves the right to update or modify these Terms & Conditions
          at any time without prior notice. Changes will be effective
          immediately upon posting on this page. Users are encouraged to review
          this page periodically.
        </p>

        <h4 className="mt-4">Governing Law</h4>
        <p>
          These terms shall be governed by and interpreted in accordance with
          the laws of India. Any disputes arising in connection with these terms
          shall be subject to the jurisdiction of the appropriate courts in
          India.
        </p>

        <h4 className="mt-4">Contact Us</h4>
        <p>
          If you have any questions regarding these Terms & Conditions, you may
          contact us through our official website or communication channels.
        </p>
      </div>
    </PageLayout>
  );
}
